import { render, staticRenderFns } from "./DiscountCodeBox.vue?vue&type=template&id=02378c20&scoped=true"
import script from "./DiscountCodeBox.vue?vue&type=script&lang=js"
export * from "./DiscountCodeBox.vue?vue&type=script&lang=js"
import style0 from "./DiscountCodeBox.vue?vue&type=style&index=0&id=02378c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02378c20",
  null
  
)

export default component.exports